export default __webpack_public_path__ + "static/media/lt.776c7aa4.mp3";